import { Button } from '@library/components/buttons';

export interface GoogleSignInButtonProps {
  disabled: boolean;
  handleOnClick: () => void;
}

export const GoogleSignInButton = ({
  disabled,
  handleOnClick
}: GoogleSignInButtonProps) => {
  return (
    <Button
      className="bg-soFresh-150 text-soClean-100 shadow-xs my-6 flex w-full justify-center rounded-lg p-3 text-sm font-semibold leading-6 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
      disabled={disabled}
      title="GoogleSignInButton"
      onClick={handleOnClick}
      type="button"
    >
      OR CONTINUE WITH GOOGLE
    </Button>
  );
};
